import { render } from "./icon-balance.vue?vue&type=template&id=f3beed56"
const script = {}

import exportComponent from "D:\\project\\newdt\\h5\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__